import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { getProjectIdOrKey } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import type { GlobalComponentsProperties } from './types.tsx';
import { getData } from './get-data/index.tsx';

export const RESOURCE_TYPE_PROJECT_GLOBAL_COMPONENTS = 'PROJECT_GLOBAL_COMPONENTS';

export const projectGlobalComponentsResource: RouteResource<GlobalComponentsProperties | null> =
	createResource<GlobalComponentsProperties | null>({
		type: RESOURCE_TYPE_PROJECT_GLOBAL_COMPONENTS,
		getKey: (matchedRoute) => getProjectIdOrKey(matchedRoute.match, matchedRoute.query),
		getData: (...args) => getData(...args),
	});
